import { Activity, Bell, FlaskConical, Home, ListChecks, Settings, ShieldCheck, TrendingUp } from "lucide-react";
import type { ReactNode } from "react";
import type { View } from "../App";

const navItems: { id: View; label: string; icon: typeof Home }[] = [
  { id: "dashboard", label: "Home", icon: Home },
  { id: "watchlist", label: "Watch", icon: ListChecks },
  { id: "signals", label: "Signals", icon: Activity },
  { id: "trades", label: "Trades", icon: TrendingUp },
  { id: "lab", label: "Lab", icon: FlaskConical },
  { id: "settings", label: "Settings", icon: Settings }
];

export function Shell({
  view,
  setView,
  children,
  onLogout
}: {
  view: View;
  setView: (view: View) => void;
  children: ReactNode;
  onLogout: () => void;
}) {
  return (
    <div className="safe-shell mx-auto min-h-dvh w-full max-w-[430px] px-5">
      <header className="sticky top-0 z-20 -mx-5 mb-4 bg-ink/88 px-5 pb-3 pt-[max(12px,env(safe-area-inset-top))] backdrop-blur-xl">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-rose">Private Command</p>
            <h1 className="text-2xl font-extrabold tracking-normal">TradeSignal</h1>
          </div>
          <div className="flex items-center gap-2">
            <button className="rounded-full border border-line bg-panel p-3 text-slate-200" aria-label="Security status">
              <ShieldCheck size={18} />
            </button>
            <button className="rounded-full border border-line bg-panel p-3 text-slate-200" aria-label="Notifications">
              <Bell size={18} />
            </button>
            <button onClick={onLogout} className="rounded-full bg-violet px-4 py-3 text-xs font-extrabold text-white shadow-glow">
              Logout
            </button>
          </div>
        </div>
      </header>
      <main className="space-y-4">{children}</main>
      <nav className="fixed inset-x-0 bottom-0 z-30 mx-auto max-w-[430px] px-3 pb-[max(10px,env(safe-area-inset-bottom))]">
        <div className="glass-card flex items-center justify-between rounded-full p-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = item.id === view;
            return (
              <button
                key={item.id}
                onClick={() => setView(item.id)}
                className={`flex h-12 min-w-12 items-center justify-center rounded-full px-3 transition ${active ? "bg-white text-ink shadow-rose" : "text-slate-400"}`}
                aria-label={item.label}
                title={item.label}
              >
                <Icon size={20} />
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
